import { VirtualTimeScheduler } from "rxjs";

export class BomItemRemovedQty{
    packingMaterialId:number;
    itemId:number;
    saleOrderId:number;
    removedQuantity:number;
    unitId?:number;
    createdUser?:string;

    constructor(packingMaterialId:number, itemId:number, saleOrderId:number, removedQuantity:number,unitId?:number,createdUser?:string){
        this.packingMaterialId = packingMaterialId;
        this.itemId = itemId;
        this.removedQuantity = removedQuantity;
        this.saleOrderId = saleOrderId;
        this.unitId = unitId;
        this.createdUser = createdUser;
    }
}